import { useForm } from "@mantine/form";
import { validateRequired, validateSchedule } from "../../../utils/validations";
import { Button, TagsInput, TextInput } from "@mantine/core";
import { Department } from "../../../types/types";
import { updateDepartmentById } from "../../../api/departmentApi";
import { updateNotification } from "../../../utils/useNotification";
import WeeklySchedule from "../../common/WeeklyWorkTimePlan";
import { useEffect } from "react";
import { normalizeWorkHours } from "../../../utils/formatWorkHours";
import dayjs from "dayjs";

const DepartmentUpdateForm = ({
  department,
  closeModal,
  updateDepartmentList,
}: {
  department: Department;
  closeModal: any;
  updateDepartmentList: any;
}) => {
  const form = useForm<any>({
    initialValues: {
      name: department?.name,
      description: department?.description,
      workHours: department?.workHours,
    },
    validate: {
      name: validateRequired,
      description: validateRequired,
      workHours: validateSchedule,
    },
  });

  const handleSubmit = async (values: any) => {
    function timeStrToLocalDateTime(timeStr: any): any {
      const today = dayjs();
      const [hour, minute] = timeStr.split(":").map(Number);
      return today.hour(hour).minute(minute).second(0).millisecond(0).toDate();
    }

    const transformed = Object.entries(values.workHours).reduce(
      (acc, [key, value]: any) => {
        if (value.start && value.end) {
          acc[key] = {
            start: timeStrToLocalDateTime(value.start) || undefined,
            end: timeStrToLocalDateTime(value.end) || undefined,
          };
        } else {
          acc[key] = {};
        }
        return acc;
      },
      {} as Record<string, { start?: string; end?: string }>
    );

    const { workHours, ...restValues } = values;

    try {
      const { data }: any = await updateDepartmentById({
        id: department?._id,
        updates: restValues,
        workHours: transformed,
      });
      if (data?.success) {
        updateNotification(data?.success);
        updateDepartmentList();
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      closeModal();
    }
  };

  useEffect(() => {
    form.setFieldValue("workHours", normalizeWorkHours(form.values.workHours));
  }, []);

  return (
    <form
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "15px",
      }}
      onSubmit={form.onSubmit(handleSubmit)}
    >
      <TextInput
        label="Departman İsmi"
        placeholder="Departman İsmi Giriniz."
        radius={10}
        maxLength={40}
        size="md"
        {...form.getInputProps("name")}
      />
      <TextInput
        label="Departman Açıklaması"
        placeholder="Departman Açıklaması Giriniz."
        radius={10}
        maxLength={140}
        size="md"
        {...form.getInputProps("description")}
      />
      <WeeklySchedule
        value={form.values.workHours}
        onChange={(updatedObject: any) => {
          form.setFieldValue("workHours", updatedObject);
        }}
        error={form.errors.workHours}
        direction={"column"}
      />
      <Button
        type="submit"
        color="#5C26FF"
        radius={10}
        disabled={!form.isDirty()}
      >
        Güncelle
      </Button>
    </form>
  );
};

export default DepartmentUpdateForm;
